import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AppBar, Box, SxProps, Theme, Toolbar } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { QuoteReminderNotifications } from 'shared/components/quote-reminder-notifications';
import { BrandLogo, Logo } from 'shared/logos';
import { useAuthState } from 'shared/stores';
import { Brands } from 'shared/types';
import { UserMenu } from './user-menu';

const rootStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
};
const userStyles: SxProps<Theme> = {
  width: 350,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};
const logosStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export function Header() {
  const { brand } = useParams<{ brand: Brands }>();
  const { instance } = useMsal();
  const authState = useAuthState();
  const authenticated = useIsAuthenticated();

  const logout = () => {
    instance.logout();
  };

  return (
    <AppBar position='static'>
      <Toolbar sx={rootStyles}>
        <Link to={ROUTES.brands}>
          <Box sx={logosStyles}>{brand ? <BrandLogo brand={brand} /> : <Logo />}</Box>
        </Link>
        {authenticated && brand && (
          <Box sx={userStyles}>
            {brand ? <QuoteReminderNotifications brand={brand} user={authState.user.get()} /> : <></>}

            {authenticated && <UserMenu logout={logout} />}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
